package com.example.readingnotes.data.remote.mapper

import com.example.readingnotes.data.remote.dto.AuthorDto
import com.example.readingnotes.data.remote.dto.PostDto
import com.example.readingnotes.data.remote.dto.PostImageDto
import com.example.readingnotes.data.remote.dto.TagDto
import com.example.readingnotes.domain.model.Author
import com.example.readingnotes.domain.model.Post
import com.example.readingnotes.domain.model.PostImage
import com.example.readingnotes.domain.model.Tag
import kotlinx.datetime.Instant

fun PostDto.toDomain(): Post =
    Post(
        id = id,
        title = title,
        // Use contentMarkdown if available, fallback to deprecated content field
        contentMarkdown = contentMarkdown ?: content ?: "",
        contentHtml = contentHtml,
        imageUrl = imageUrl,
        imageIds = imageIds,
        images = images?.map { it.toDomain() },
        tags = tags?.map { it.toDomain() },
        status = status,
        createdAt = Instant.parse(createdAt),
        updatedAt = Instant.parse(updatedAt),
        authorId = authorId,
        author = author?.toDomain(),
    )

fun TagDto.toDomain(): Tag =
    Tag(
        id = id,
        name = name,
        color = color,
        createdAt = Instant.parse(createdAt),
        updatedAt = Instant.parse(updatedAt),
    )

fun AuthorDto.toDomain(): Author =
    Author(
        id = id,
        username = username,
    )

fun PostImageDto.toDomain(): PostImage =
    PostImage(
        id = id,
        url = url,
        originalName = originalName,
        mimeType = mimeType,
        width = width,
        height = height,
    )

fun List<PostDto>.toDomain(): List<Post> = map { it.toDomain() }
